import styled, { css } from 'styled-components';

export const buttonStyles = css`
  font-size: 1.1rem;
  font-weight: 600;
  background: transparent;
  border-radius: 5px;
  border: 2px solid ${(p) => p.theme.accent.primary};
  color: ${(p) => p.theme.accent.primary};
  padding: 0.6rem 1.8rem;
  cursor: pointer;
  transition: 0.2s ease-in-out;

  @media screen and (max-width: 767px) {
    padding: 0.4rem 1rem;
    font-size: 0.9rem;
  }

  @media screen and (max-height: 600px) {
    padding: 0.25rem 0.8rem;
    font-size: 0.8rem;
  }

  @media screen and (max-height: 600px) and (min-width: 900px) {
    padding: 0.4rem 1.2rem;
    font-size: 0.9rem;
  }

  ${(p) =>
    p.marginRight &&
    css`
      margin-right: 1rem;
    `}

  ${(p) =>
    p.primary &&
    css`
      background: ${(p) => p.theme.accent.primary};
      color: ${(p) => p.theme.background};
    `}

 
  &:hover {
    filter: ${(p) => (p.primary ? 'saturate(150%)' : 'saturate(50%)')};
  }

  &:active {
    filter: brightness(130%);
  }
`;

const Button = styled.button`
  ${buttonStyles}
`;

export default Button;
